import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-secondary-btn',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './secondary-btn.component.html',
  styleUrl: './secondary-btn.component.scss'
})
export class SecondaryBtnComponent {
  @Input() mb: string = "0px";
  @Input() mt: string = "0px";
  @Input() destructive: boolean = false;
  @Input() variant: string | null = null;

}
